import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaReferenceDefinition } from './TypedDefinition'

export const SchemaReferencePlugin = createSchemaPlugin(
  'Schema.Reference',
  SchemaReferenceDefinition
)
